export default "__VITE_ASSET__C4BMYZVP__"